import * as React from 'react';
import Select from 'react-select';
import { Alert, Button, Col, Fade, Input, Label, Modal, ModalBody, ModalHeader, Row, Spinner } from 'reactstrap';
import Swal from 'sweetalert2';
import { useAppDispatch, useAppSelector } from '../../hooks/index';
import {
    adminEntityAffiliateAuditSave, adminEntityAuditSave, adminEntityDocumentSave, AffiliateReporting, Afr, CRA, addDocumentRelationship, ensureInProgress, EntityDocumentSave, getSelectedAfr
} from '../../redux/AfrSlice';
import { DocumentReference, DocumentRelationship, downloadDocumentInfoById, uploadFile } from '../../redux/DocumentsSlice';
import { Entity, EntityReference, getSelectedEntity } from '../../redux/EntitySlice';
import { TaxonomyTypeEnum } from '../../redux/TaxonomyVersionSlice';
import { UserRoleEnum, selectUserRole } from '../../redux/UserSlice';
import enums from '../../utils/enums';
import utilityHelper from '../../utils/utilityHelper';
import { GenericFileUploader } from '../core/GenericFileUploader';
import { setIsDirty } from '../../redux/MiscSlice';


const AdminDocumentUploader = (props: { taxonomyType : TaxonomyTypeEnum}) => {

    const dispatch = useAppDispatch();
    const currentAfr: Afr | null = useAppSelector(getSelectedAfr);
    const entity: Entity | null = useAppSelector(getSelectedEntity);
    const userRoleSelector = useAppSelector(selectUserRole);

    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const [uploadIsInProgress, setUploadIsInProgress] = React.useState<boolean>(false)

    const defaultAffiliateOption = { value: "0", label: "Select An Affiliate" };
    const defaultDocumentTypeOption = { value: "0", label: "Select A Document Type" };

    const [selectedAffiliateOption, setSelectedAffiliateOption]
        = React.useState<{ value: string; label: string }>(defaultAffiliateOption);

    const [selectedDocumentTypeOption, setSelectedDocumentTypeOption]
        = React.useState<{ value: string; label: string }>(defaultDocumentTypeOption);

    const [affiliateOptions, setAffiliateOptions]
        = React.useState<Array<{ value: string; label: string; }>>([]);

    const [documentTypeOptions, setDocumentTypeOptions]
        = React.useState<Array<{ value: string; label: string; }>>([]);

    const [file, setFile] = React.useState<File>();

    const [isAffiliateUploader, setIsAffiliateUploader] = React.useState<boolean>(false);

    const [auditTypeIsNotDEW, setAuditTypeIsNotDEW] = React.useState<boolean>(true);

    const toggleModal = () => {
        setModalIsOpen(!modalIsOpen);
    }

    const showDEWAuditAlert = function () {
        if (currentAfr) {
            switch (currentAfr.status) {
                case "RE_CERTIFIED_BY_ENTITY":
                case "CERTIFIED_BY_ENTITY":
                    return false;
            }
        } else {
            return false;
        }
        if (auditTypeIsNotDEW) {
            return false;
        }
        if (selectedDocumentTypeOption.value === "AUDIT") {
            return true;
        }
        return false;
    }
    const showDEWAuditCertifiedAlert = function (selDocType: any) {
        var auditType = "AUDIT";
        if (currentAfr) {
            switch (currentAfr.status) {
                case "RE_CERTIFIED_BY_ENTITY":
                case "CERTIFIED_BY_ENTITY":
                    break;

                default:
                    return false;
            }
            if (currentAfr.currentversion && currentAfr.currentversion.audit && currentAfr.currentversion.audit.auditType) {
                auditType = currentAfr.currentversion.audit.auditType;
            }
        } else {
            return false;
        }
        if (auditType !== "DEW") {
            return false;
        }
        return true;
    }
    const initDocumentTypeOptionsForAffiliates = (affiliateReporting: AffiliateReporting) => {

        let documentRoleOptions: Array<{ label: string; value: string }> = [];

        documentRoleOptions.push(defaultDocumentTypeOption);
        setSelectedDocumentTypeOption(defaultDocumentTypeOption);

        var propertyNames = Object.keys(enums.documentRoleLabel);

        for (var i = 0; i < propertyNames.length; i++) {
            let documentRoleOption: { label: string; value: string } = { label: "", value: "" };
            documentRoleOption.label = enums.documentRoleLabel[propertyNames[i]];
            documentRoleOption.value = propertyNames[i];
            documentRoleOptions.push(documentRoleOption);
        }
        if (affiliateReporting && affiliateReporting.affiliateReference) {
            if (affiliateReporting.affiliateReference.category == CRA) {
                if (currentAfr && currentAfr.year >= 2021) {
                    documentRoleOptions = documentRoleOptions.filter(element => element.label == enums.documentRoleLabel.AUDIT
                        || element.label == enums.documentRoleLabel.BUDGET_VARIANCE_REPORT);
                    setDocumentTypeOptions(documentRoleOptions);
                } else {
                    documentRoleOptions = documentRoleOptions.filter(element => element.label == enums.documentRoleLabel.AUDIT);
                    setDocumentTypeOptions(documentRoleOptions);
                    handleDocumentTypeOptionChange(documentRoleOptions[0]);
                }               
            } else {
                documentRoleOptions = documentRoleOptions.filter(element => element.label == enums.documentRoleLabel.BUDGET_VARIANCE_REPORT);
                setDocumentTypeOptions(documentRoleOptions);
                handleDocumentTypeOptionChange(documentRoleOptions[0]);
            }           
        }       
    }

    const initDocumentTypeOptionsForEntity = () => {
        let documentRoleOptions: Array<{ label: string; value: string }> = [];

        documentRoleOptions.push(defaultDocumentTypeOption);
        setSelectedDocumentTypeOption(defaultDocumentTypeOption);
        var roleDefs : any = {};
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.AFR:
                roleDefs = enums.documentRoleLabel;
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_29:
                if (currentAfr && currentAfr.year >= 2024) {
                    roleDefs = enums.CR29DocumentRoleLabel_2024;
                } else {
                    roleDefs = enums.CR29DocumentRoleLabel;
                }
                break;
        }
        var propertyNames = Object.keys(roleDefs);
        for (var i = 0; i < propertyNames.length; i++) {
            var propName = propertyNames[i];
            if (propName === "AUDIT") {
                var selDocType: any = {
                    label: "",
                    value: "AUDIT"
                };
                if (showDEWAuditCertifiedAlert(selDocType)) {
                    continue;
                }
            }
            let documentRoleOption: { label: string; value: string } = { label: "", value: "" };
            documentRoleOption.label = roleDefs[propName];
            documentRoleOption.value = propName;
            documentRoleOptions.push(documentRoleOption);
        }

        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.AFR:
                //2019 and prior should not have budget variance and impact fee options
                if (currentAfr && currentAfr.year <= 2019) {
                    documentRoleOptions = documentRoleOptions.filter(element => element.label == enums.documentRoleLabel.AUDIT);
                    setDocumentTypeOptions(documentRoleOptions);
                    if (documentRoleOptions.length > 0) {
                        handleDocumentTypeOptionChange(documentRoleOptions[0]);
                    }
                } else if (currentAfr && currentAfr.year == 2020) {
                    documentRoleOptions = documentRoleOptions.filter(element => element.label == enums.documentRoleLabel.AUDIT
                        || element.label == enums.documentRoleLabel.IMPACT_FEE_EXCEPTION
                        || element.label == enums.documentRoleLabel.IMPACT_FEE_WAIVER
                        || element.label == defaultDocumentTypeOption.label);
                    setDocumentTypeOptions(documentRoleOptions);
                } else {
                    //no filters
                    setDocumentTypeOptions(documentRoleOptions);
                }
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_29:
                //no filters
                setDocumentTypeOptions(documentRoleOptions);
                break;
        }
    }

    const initAffiliateOptions = () => {

        if (currentAfr) {
            if (currentAfr.affiliateReporting && currentAfr.affiliateReporting.length > 0) {
                let result: Array<{ value: string; label: string; }> = [];

                result.push(defaultAffiliateOption);
                for (var i = 0; i < currentAfr.affiliateReporting.length; i++) {
                    var affRep: AffiliateReporting = currentAfr.affiliateReporting[i];
                    var affiliate: EntityReference | null = affRep.affiliateReference;
                    if (!affiliate) {
                        continue;
                    }
                    switch (affRep.reportingType) {
                        case enums.affiliatedEntityReportingType.independent:
                        case enums.affiliatedEntityReportingType.nonComponentUnit:
                        case enums.affiliatedEntityReportingType.notSpecified:
                            continue;
                    }
                    if ((currentAfr.year >= 2019 && affiliate.category == CRA)
                        || (currentAfr.year >= 2021 && affiliate.category != CRA)) {

                        var affiliateName = affiliate.name;
                        var affiliateCode = affiliate.code;
                        if (affiliateName && affiliateCode) {
                            result.push({
                                label: affiliateName,
                                value: affiliateCode
                            })
                        }
                    }
                }

                //if multiple options
                if (result.length > 2) {
                    setAffiliateOptions(result);
                }
                //if single option remove default option and select only option
                else if (result.length == 2) {
                    result = result.filter((element) => element.value != defaultAffiliateOption.value);
                    setAffiliateOptions(result);
                    handleAffiliateOptionChange(result[0]);
                }
            }
        }
    }

    const handleAffiliateOptionChange = (e: { value: string, label: string }) => {
        //TODO CHECK DEW type 
        //to potentially make audit available for upload
        //&& auditTypeIsNotDEW == true
        if (currentAfr) {
            if (currentAfr.affiliateReporting && currentAfr.affiliateReporting.length > 0) {

                var foundAffiliate = currentAfr.affiliateReporting.find(element => element.affiliateReference
                    && element.affiliateReference.code == e.value);
                if (foundAffiliate) {
                    setSelectedAffiliateOption(e);
                    initDocumentTypeOptionsForAffiliates(foundAffiliate)
                }
            }
        }
    }

    const handleDocumentTypeOptionChange = (e: { value: string, label: string }) => {
        setSelectedDocumentTypeOption(e);
    }

    const handleAffiliateUploadClose = () => {
        setSelectedAffiliateOption(defaultAffiliateOption);
        setSelectedDocumentTypeOption(defaultDocumentTypeOption);
        setAffiliateOptions([]);
        setDocumentTypeOptions([]);
        setIsAffiliateUploader(false);
    }

    const saveRoleDocumentUpload = async function (documentGuid: string, aff : string | null, r : string ) {
        if (currentAfr && entity) {
            var docRefResult = await dispatch(downloadDocumentInfoById(documentGuid));
            if (!docRefResult || !docRefResult.payload) {
                alert("No document for " + documentGuid)
                toggleModal();
                return;
            }
            var docRef: DocumentReference = docRefResult.payload;
            var now = new Date().toISOString();
            let docRel: DocumentRelationship = {
                name: docRef.uri,
                affiliate: aff,
                documentId: documentGuid,
                role: r,
                timestamp: now
            }

            dispatch(addDocumentRelationship(docRel));
            // Turn ON the dirty flag in redux
            dispatch(setIsDirty({ IsDirty: true, Page: "" }));
            toggleModal();
        }
    }
    const saveEntityUpload = async function (documentGuid: string) {
        saveRoleDocumentUpload(documentGuid, null, selectedDocumentTypeOption.value);
    }


    const saveAffiliateUpload = async function (documentGuid: string) {
        saveRoleDocumentUpload(documentGuid, selectedAffiliateOption.value, selectedDocumentTypeOption.value);
    }

    const handleAffiliateFileUpload = async function (actionType: string, entityType: string, entityId: string, uploadedFile: File | undefined) {
        if (uploadedFile !== undefined) {

            if (currentAfr && entity) {
                setUploadIsInProgress(true);
                var documentGuid = "";

                documentGuid = await uploadFile(uploadedFile, selectedDocumentTypeOption.label, dispatch);

                await saveAffiliateUpload(documentGuid);
                setUploadIsInProgress(false);
            }
        }
    }

    const handleEntityFileUpload = async function (actionType: string, entityType: string, entityId: string, uploadedFile: File | undefined) {
        if (uploadedFile !== undefined) {

            if (currentAfr && entity) {
                setUploadIsInProgress(true);
                var documentGuid = "";

                documentGuid = await uploadFile(uploadedFile, selectedDocumentTypeOption.label, dispatch);

                await saveEntityUpload(documentGuid);
                setUploadIsInProgress(false);
            }
        }
    }

    const shouldShowAffiliateOptions = () => {
        let hasCRAForAuditOrHasAffiliatesFor1103: boolean = false;
        if (currentAfr && props.taxonomyType === TaxonomyTypeEnum.AFR) {
            if (currentAfr.affiliateReporting) {
                if (currentAfr.affiliateReporting.length > 0) {
                    var foundCRA = currentAfr.affiliateReporting.find(element => element && element.affiliateReference
                                                                                            && element.affiliateReference.category == CRA);

                    var foundNonCRA = currentAfr.affiliateReporting.find(element => element && element.affiliateReference
                                                                                            && element.affiliateReference.category != CRA);

                    if ((currentAfr.year >= 2019 && foundCRA)
                        || (currentAfr.year >= 2021 && foundNonCRA )) {
                        if (foundCRA) {
                            hasCRAForAuditOrHasAffiliatesFor1103 = true;
                        }
                    }
                }
            }
        }
        
        return hasCRAForAuditOrHasAffiliatesFor1103;
    }

    const hideDocUploader = function (): boolean {
        if (!userRoleSelector) {
            return true;
        }
        if (!currentAfr) {
            return true;
        }
        if (currentAfr.status === "VERIFIED") {
            return true;
        }
        var result: boolean = false;
        switch (props.taxonomyType) {
            case TaxonomyTypeEnum.COURT_REPORTING_939:
                result = true;
                break;

            case TaxonomyTypeEnum.COURT_REPORTING_29:
                result = false;
                break;

            case TaxonomyTypeEnum.AFR:
                if (userRoleSelector !== UserRoleEnum.Admin) {
                    result = true;
                }
                break;

        }
        return result;
    }

    const entityUploadRenderRightSide = (<React.Fragment>
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Label>{(entity) ? entity.name : ""}</Label>
            </Col>
        </Row>
        {showDEWAuditAlert() &&
            (<Row>
                <Alert color="danger">
                <p>This AFR currently has a DEW, not an Audit.</p>
                <p>Uploading an Audit PDF will create an Audit and remove any DEW facts.</p>
                </Alert>
            </Row>)
        }
        {showDEWAuditCertifiedAlert(selectedDocumentTypeOption) &&
            (<Row>
                <Alert color="danger">
                    <p>This AFR is <b>Certified</b> and has a DEW, not an Audit.</p>
                    <p>The Audit option is not available in this state, since uploading an Audit document for a DEW AFR would result in significant data changes.<br/>If you need to upload an Audit, you must create a new Version to allow for full editing.</p>
                </Alert>
            </Row>)
        }
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Select
                    value={selectedDocumentTypeOption}
                    onChange={(e: { value: string, label: string }) => { handleDocumentTypeOptionChange(e) }}
                    options={documentTypeOptions}
                />
            </Col>
        </Row>
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Fade
                    in={selectedDocumentTypeOption.value != defaultDocumentTypeOption.value}
                >
                    <Spinner children={''} style={{ width: '1rem', height: '1rem' }}
                        type="grow" color="warning"
                        hidden={uploadIsInProgress == false} />
                    <div hidden={uploadIsInProgress == true}>
                        <GenericFileUploader
                            actionType={"UPLOAD_PDF"}
                            clickAction={handleEntityFileUpload}
                            entityType={""}
                            entityId={""}
                            fileExtensions={".PDF"}
                            uploadLegend={"Upload " + selectedDocumentTypeOption.label}
                            icon="bi bi-arrow-bar-up"
                            isEnabled={true}
                            uploadedFile={file}
                        />
                    </div>
                </Fade>
            </Col>
        </Row> </React.Fragment>);

    const affiliateUploadRenderRightSide = (<React.Fragment>
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Select
                    value={selectedAffiliateOption}
                    onChange={(e: { value: string, label: string }) => { handleAffiliateOptionChange(e); }}
                    options={affiliateOptions}
                />
            </Col>
        </Row>
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Fade
                    in={selectedAffiliateOption.value != defaultAffiliateOption.value}
                >
                    <Select
                        value={selectedDocumentTypeOption}
                        onChange={(e: { value: string, label: string }) => { handleDocumentTypeOptionChange(e) }}
                        options={documentTypeOptions}
                    />
                </Fade>
            </Col>
        </Row>
        <Row style={{ marginBottom: "5em" }}>
            <Col>
                <Fade
                    in={(selectedAffiliateOption.value != defaultAffiliateOption.value
                        && selectedDocumentTypeOption.value != defaultDocumentTypeOption.value) == true}
                >
                    <Spinner children={''} style={{ width: '1rem', height: '1rem' }}
                        type="grow" color="warning"
                        hidden={uploadIsInProgress == false} />
                    <div hidden={uploadIsInProgress == true}>
                        <GenericFileUploader
                            actionType={"UPLOAD_PDF"}
                            clickAction={handleAffiliateFileUpload}
                            entityType={""}
                            entityId={""}
                            fileExtensions={".PDF"}
                            uploadLegend={"Upload " + selectedDocumentTypeOption.label}
                            icon="bi bi-arrow-bar-up"
                            isEnabled={true}
                            uploadedFile={file}
                        />
                    </div>                    
                </Fade>
            </Col>
        </Row> </React.Fragment>);

    const entityWithAffiliatesLeftSide = (<React.Fragment>
        <ul>
            <li style={{ marginBottom: "3em" }}>
                <Input
                    type="radio"
                    value={"Entity Uploader"}
                    name="uploader-chooser"
                    onChange={(e) => { setIsAffiliateUploader(false); }}
                    checked={isAffiliateUploader == false} />
                {"Entity Uploader"}
            </li>
            <li style={{ marginBottom: "3em" }}>
                <Input
                    type="radio"
                    value={"Affiliate Uploader"}
                    name="uploader-chooser"
                    onChange={(e) => { setIsAffiliateUploader(true); }}
                    checked={isAffiliateUploader == true} />
                {"Affiliate Uploader"}
            </li>
        </ul>
    </React.Fragment>);

    const entityWithoutAffiliatesLeftSide = (<React.Fragment>
        {(entity) ? entity.name : ""}
    </React.Fragment>)

    const adminUploaderRender = (<React.Fragment>
        <div className="my-3">
            <Button className="mr-3 btn btn-success"
                onClick={toggleModal}
            ><i className="bi bi-arrow-bar-up"></i>
            </Button>
            Upload Document
        </div>
        <Modal isOpen={modalIsOpen} toggle={toggleModal} size="xl">
            <ModalHeader style={{}}>
                <Label>Admin Document Upload</Label>
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md="4" style={{ margin: "auto" }}>
                        {shouldShowAffiliateOptions()
                            ? entityWithAffiliatesLeftSide : entityWithoutAffiliatesLeftSide}
                    </Col>
                    <Col md="8" style={{ borderLeft: "groove", padding: "3em" }}>
                        {isAffiliateUploader == false ? entityUploadRenderRightSide : affiliateUploadRenderRightSide}
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    </React.Fragment>);

    React.useEffect(() => {
        setAuditTypeIsNotDEW(true);
        if (currentAfr != null) {
            if (currentAfr && currentAfr.currentversion && currentAfr.currentversion.audit
                && currentAfr.currentversion.audit.auditType == "DEW") {
                setAuditTypeIsNotDEW(false);
            }
        }
    }, [currentAfr])

    React.useEffect(() => {

        if (modalIsOpen == true) {
            if (isAffiliateUploader == false) {
                initDocumentTypeOptionsForEntity();
            }
            else {
                initAffiliateOptions();
            }
        } else {
            handleAffiliateUploadClose();
        }

    }, [modalIsOpen, isAffiliateUploader])


    return (
        hideDocUploader() ? <></> : adminUploaderRender
    );
}

export default AdminDocumentUploader;